/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SearchRuleOrderValue {
    Description = 'Description',
    Comment = 'Comment',
    BrandAndMarket = 'BrandAndMarket',
    Channel = 'Channel',
    Supplier = 'Supplier',
    Relevance = 'Relevance'
}

export function SearchRuleOrderValueFromJSON(json: any): SearchRuleOrderValue {
    return SearchRuleOrderValueFromJSONTyped(json, false);
}

export function SearchRuleOrderValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRuleOrderValue {
    return json as SearchRuleOrderValue;
}

export function SearchRuleOrderValueToJSON(value?: SearchRuleOrderValue | null): any {
    return value as any;
}

